/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type AdminDashboard, dashboardApi } from '../api/dashboard.js';

/**
 * The admin dashboard overview. Polls every 60s and refetches on window focus so
 * the figures stay close to real-time without a socket.
 */
export function useAdminDashboard(): UseQueryResult<AdminDashboard> {
  return useQuery({
    queryKey: ['admin', 'dashboard'],
    queryFn: () => dashboardApi.admin(),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
